// extracted by mini-css-extract-plugin
module.exports =  {"button":"_32bbee5fda--button--DRcAC"};